import { render, staticRenderFns } from "./fornecedor-extrato.vue?vue&type=template&id=72a84af8&scoped=true"
import script from "./fornecedor-extrato.vue?vue&type=script&lang=js"
export * from "./fornecedor-extrato.vue?vue&type=script&lang=js"
import style0 from "./fornecedor-extrato.vue?vue&type=style&index=0&id=72a84af8&prod&scoped=true&lang=css"
import style1 from "./fornecedor-extrato.vue?vue&type=style&index=1&id=72a84af8&prod&scoped=true&lang=css"
import style2 from "./fornecedor-extrato.vue?vue&type=style&index=2&id=72a84af8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a84af8",
  null
  
)

export default component.exports